export class CreateFindingExclusionResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "findingExclusion",
            "baseName": "findingExclusion",
            "type": "FindingExclusion",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateFindingExclusionResponse.attributeTypeMap;
    }
    constructor() {
    }
}
